import type { Data } from '@dnd-kit/abstract';

import { useDraggable } from '@dnd-kit/react';
import { Slot } from '@radix-ui/react-slot';
import { cn } from '@repo/lib/cn';

import type { DraggableItemProps } from '.';

export function DraggableItem<T extends Data>(draggableItemProps: DraggableItemProps<T>) {
  const {
    id,
    data,
    isDraggingClassName = 'opacity-50',
    args,
    className,

    ...props
  } = draggableItemProps;
  const { ref: setNodeRef, isDragging } = useDraggable({
    id,
    data,
    ...args,
  });

  return (
    <Slot
      ref={setNodeRef}
      data-dragging={isDragging ? 'true' : 'false'}
      aria-disabled={args?.disabled}
      className={cn('sortable-item cursor-pointer select-none active:cursor-grabbing aria-disabled:cursor-not-allowed', isDragging && 'opacity-50', isDragging && isDraggingClassName, className)}
      {...props}
    />
  );
}
